import { useState } from "react";
import { motion } from "framer-motion";

import { Accordion } from "../accordion/Accordion.component";

import logo from './DOC-Logo-RGB.png';
import mag from './magnifying-glass.ded40be2.svg';
import close from "./close-x.c831475b.svg";
import { Button, ContentWrapper } from './Mobile.styles';


export const Mobile = ({menuData, secondaryData, searchData}) => {
    const formVariants = {
        open: {display: "block", opacity: 1, right: '2rem'},
        closed: {display: "none", opacity: 0, right: '-1300px'},
    };

    const modelOverlayVariants = {
        open: {display: "block", opacity: 1},
        closed: {display: "none", opacity: 0},
    };

    const menuVariants = {
        open: {display: "block", opacity: 1, left: 0},
        closed: {display: "none", opacity: 0, right: '-1300px'},
    };

    const [isOpen, setIsOpen] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [expanded, setExpanded] = useState(null);

    return (<nav id="mobile-nav">
        <button id="open-nav" onClick={() => setMenuIsOpen(isOpen => !isOpen)} aria-label="open-nav">
            <span id="top"></span>
            <span id="middle"></span>
            <span id="bottom"></span>
        </button>
        <figure className="col-3 mar-r-1 doc-logo">
            <a href="https://vadoc.virginia.gov/">
                <img width="100" height="100" src={logo} alt="Virginia Department of Corrections Logo" />
            </a>
        </figure>
        <Button id="open-search" background={mag} onClick={() => setIsOpen(isOpen => !isOpen)} aria-label="open-search" />
        <motion.form animate={isOpen ? "open" : "closed"} variants={formVariants} action={searchData} className="site-search" method="post">
            <label className="accessibility-hidden" htmlFor="search-term">Search Term</label>
            <input id="search-term-mobile" type="text" name="search" placeholder="Search the Site" />
            <Button type="submit" background={mag}><span className="accessibility-hidden">search</span></Button>
        </motion.form>
        <motion.div animate={menuIsOpen ? "open" : "closed"}  variants={modelOverlayVariants} className="modal-overlay" />
        <motion.div animate={menuIsOpen ? "open" : "closed"}  exit="closed" variants={menuVariants} transition={{ duration: 1, ease: [0.04, 0.62, 0.23, 0.98] }} className="mobile-nav-window">
        <ContentWrapper>    
            <div className="mobile-nav-content flyout-level">
                            <p className="resources-for">Resources For</p>
                            <ul>
                                {menuData.map((link, i) => (
                                    <Accordion key={i} i={i} expanded={expanded} setExpanded={setExpanded} element={link} />
                                ))
                                }
                                {
                                secondaryData.map((link, i) => {
                                    if (i === 0) {
                                        return null;
                                    }
                                    if (i === 1) {
                                        return <li id="mobile-facilities-link" key={i} className="top-level">
                                        <a href={link.Url}>{link.Name}</a>
                                    </li>
                                    }
                                    return <li key={i} className="top-level">
                                        <a href={link.Url}>{link.Name}</a>
                                    </li>
                                })
                                }
                            </ul>
                </div>
                <Button className="close-mobile-nav" background={close} onClick={() => setMenuIsOpen(isOpen => !isOpen)}>
                    <span className="accessibility-hidden">close mobile navigation window</span>
                </Button>
            </ContentWrapper>
        </motion.div>
    </nav>);
}